import React from 'react';

import classNames from 'classnames';

import { Macro } from '../types';

type Props = {
  macros: Macro[];
  onSelect: (body: string) => void;
  onManage?: () => void;
  extraClassName?: string;
};

/**
 * Telescope's QuickResponsesDropdown, fed by the support service's macros.
 * Selection is by click, same as the original — no arrow-key navigation.
 */
const QuickReplyDropdown: React.FC<Props> = ({
  macros,
  onSelect,
  onManage,
  extraClassName,
}: Props) => {
  if (macros.length === 0 && !onManage) return null;

  return (
    <div
      className={classNames(
        'flex flex-col overflow-y-auto overflow-x-hidden max-h-80 max-w-3/5 min-w-80 bg-white-0.0 shadow rounded absolute z-50 py-3',
        extraClassName
      )}
    >
      <p className="text-xs text-gray-1.0 font-semibold pb-2 px-4 uppercase">Quick replies</p>
      {macros.map(({ id, title, body }, index) => (
        <div key={id}>
          <button
            type="button"
            className="w-full text-left hover:bg-white-1.0 px-4 py-2 cursor-pointer"
            onClick={() => onSelect(body)}
          >
            <p className="font-semibold text-sm truncate text-black-1.0">{title}</p>
            <p className="text-sm truncate text-gray-1.0">{body}</p>
          </button>
          {macros.length !== index + 1 && <div className="border-t border-white-1.0" />}
        </div>
      ))}
      {macros.length === 0 && <p className="px-4 py-2 text-sm text-gray-1.0">None yet.</p>}
      {onManage && (
        <button
          type="button"
          className="px-4 pt-2 mt-1 text-sm font-medium text-left border-t text-primary-2.0 border-white-1.0 hover:underline"
          onClick={onManage}
        >
          Manage quick replies
        </button>
      )}
    </div>
  );
};

export default QuickReplyDropdown;
